export class WellKnownDirectories {
    public static ExternFormsDefaultCheckoutDirectory = "extern.forms";
    public static DiadocFormsDefaultCheckoutDirectory = "diadoc.forms";
    public static RpnFormsDefaultCheckoutDirectory = "rpn.forms";

    public static FormsDirectory = "forms";
    public static CandyFarmDirectory = "candy.farm";

    public static CandySubdirectoryName = "Candy";
    public static FormJsonFileName = "form.json";
    public static GeneratedFormSubdirectory = "form";

    public static TestFarmDir = "candy.farm";
}
